const domain = window.location.hostname.split(".");
const clientSystem = domain[0] === "cbr" ? "newcbr" : domain[0];
let client = domain[0];
let system = domain[1];
let env = domain[2];
let activeNewProfile = false;
let activityScheduleId;

//temporario
if (client === "localhost") {
  client = "amib";
  system = "icongresso";
  env = "teste";
}

if (client === "sbem") {
  activeNewProfile = true;
  activityScheduleId = 1472;
}

const ssoEnabledClients = ["amib"];

const dev = {
  baseURL: `https://${client}.ws.teste.itarget.com.br/`,
  baseURLV2: `http://localhost/`,
  authURL: `http://localhost`,
  client,
  urlIcase: `https://icase.${clientSystem}.homologacao.itarget.com.br/`,
  urlIcongresso: `https://icongresso.${clientSystem}.homologacao.itarget.com.br/`,
  urlHub: `https://${client}.hub.teste.itarget.com.br/`,
};

const homol = {
  baseURL: `https://${client}.ws.homologacao.itarget.com.br/`,
  baseURLV2: `https://${client}.api.teste.itarget.com.br/`,
  authURL: `https://auth.homologacao.itarget.com.br`,
  client,
  urlIcase: `https://icase.${clientSystem}.homologacao.itarget.com.br/`,
  urlIcongresso: `https://icongresso.${clientSystem}.homologacao.itarget.com.br/`,
  urlHub: `https://${client}.hub.teste.itarget.com.br/`,
};

const prod = {
  baseURL: `https://${client}.ws.itarget.com.br/`,
  baseURLV2: `https://${client}.api.itarget.com.br/`,
  authURL: `https://auth.itarget.com.br`,
  client,
  urlIcase: `https://icase.${clientSystem}.itarget.com.br/`,
  urlIcongresso: `https://icongresso.${clientSystem}.itarget.com.br/`,
  urlHub: `https://${client}.hub.itarget.com.br/`,
};

const test = {
  baseURL: `https://${client}.ws.teste.itarget.com.br/`,
  baseURLV2: `https://${client}.api.teste.itarget.com.br/`,
  authURL: `https://auth.teste.itarget.com.br`,
  client,
  urlIcase: `http://icase.${clientSystem}.teste.itarget.com.br/`,
  urlIcongresso: `http://icongresso.${clientSystem}.teste.itarget.com.br/`,
  urlHub: `https://${client}.hub.teste.itarget.com.br/`,
};

const config =
  env === "homologacao"
    ? homol
    : env === "teste"
    ? test
    : env === "dev"
    ? dev
    : prod;

config.system = system;

if (
  window.location.hostname === "localhost" ||
  window.location.hostname.indexOf("127.0.0.1") === 0
) {
  config.authURL = "http://localhost";
  config.baseURLV2 = "http://localhost/";
}

export default {
  ...config,
  activeNewProfile,
  activityScheduleId,
  ssoEnabledClients,
  ssoEnabled: ssoEnabledClients.includes(client),
};
